export default __webpack_public_path__ + "static/media/lacma_logo.1d8485af.png";